import * as React from 'react'
import type { SVGProps } from 'react'
import PropTypes from 'prop-types'

/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number
  alt?: string
}
function IconWhiskDefault(
  { srText, size = 'md', className = '', ...props }: Props,
) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`
  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={24}
        height={25}
        fill='none'
        viewBox='0 0 24 24'
        aria-hidden='true'
        role='img'
        className={newClassName}
        {...props}
      >
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M18.407 12.88c1.381-1.38 2.31-3.04 2.614-4.674.15-.804.136-1.547-.027-2.202a7.4 7.4 0 0 1-.462 1.165c-.69 1.412-1.884 3.002-3.36 4.477-1.962 1.963-4.043 3.345-5.633 3.807.347.087.712.147 1.107.147 1.905 0 4.059-1.016 5.761-2.72m-6.79-6.787c-1.381 1.38-2.31 3.042-2.615 4.676-.149.803-.136 1.547.028 2.201q.156-.538.46-1.164c.692-1.411 1.885-3.002 3.361-4.478 1.962-1.963 4.043-3.345 5.633-3.806a4.5 4.5 0 0 0-1.107-.147c-1.905 0-4.058 1.016-5.76 2.718m1.852 1.85c-1.41 1.41-2.544 2.917-3.195 4.245-.392.8-.57 1.488-.526 1.944l9.905-9.904c-1.733-.177-4.784 2.314-6.184 3.715m3.086 3.086c1.41-1.41 2.544-2.916 3.194-4.244.392-.802.571-1.49.527-1.946l-9.905 9.905c1.669.172 4.632-2.163 6.184-3.715m.822-8.529c1.353 0 2.51.442 3.345 1.276 1.094 1.094 1.506 2.724 1.157 4.59-.336 1.805-1.35 3.629-2.855 5.132-1.862 1.863-4.246 2.975-6.378 2.975-1.353 0-2.51-.441-3.344-1.277-1.095-1.094-1.505-2.724-1.158-4.59C8.481 8.802 9.494 6.98 11 5.475 12.86 3.612 15.246 2.5 17.377 2.5M8.685 15.813c.424.425.916.758 1.461 1.009L4.98 21.986c-.33.33-.768.512-1.234.512s-.904-.182-1.234-.512A1.73 1.73 0 0 1 2 20.752c0-.465.182-.904.512-1.235l5.166-5.166c.25.541.58 1.036 1.007 1.462'
          clipRule='evenodd'
        />
      </svg>
    </>
  )
}
IconWhiskDefault.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>
export default IconWhiskDefault
